import { useTranslation } from 'react-i18next';

import { Button } from '@/components/atoms/Buttons';

interface MeasurementActionsProps {
    isEditing: boolean;
    canSave: boolean;
    scanEnabled: boolean;
    scanRunning: boolean;
    canMove: boolean;
    moveDisabledReason: string;
    onEdit: () => void;
    onCancel: () => void;
    onSave: () => void;
    onMove: () => void;
    onStop: () => void;
}

export function MeasurementActions(props: MeasurementActionsProps) {
    const {
        isEditing,
        canSave,
        scanEnabled,
        scanRunning,
        canMove,
        moveDisabledReason,
        onEdit,
        onCancel,
        onSave,
        onMove,
        onStop,
    } = props;
    const { t } = useTranslation();

    if (isEditing) {
        return (
            <>
                <Button
                    variant="secondary"
                    trackingId="winch_measurement_cancel"
                    onClick={onCancel}>
                    {t('winchControl.card.cancel')}
                </Button>
                <Button
                    variant="primary"
                    trackingId="winch_measurement_save"
                    onClick={onSave}
                    disabled={!canSave}>
                    {t('winchControl.card.save')}
                </Button>
            </>
        );
    }

    return (
        <>
            <Button variant="secondary" trackingId="winch_measurement_edit" onClick={onEdit}>
                {t('winchControl.card.edit')}
            </Button>
            {scanRunning ? (
                <Button
                    variant="danger"
                    trackingId="winch_measurement_stop"
                    onClick={onStop}
                    tooltip={t('winchControl.button.stopScanTooltip')}
                    tooltipPlacement="left">
                    {t('winchControl.button.stop')}
                </Button>
            ) : (
                <Button
                    variant="primary"
                    trackingId="winch_measurement_move"
                    onClick={onMove}
                    disabled={!canMove}
                    tooltip={
                        !canMove
                            ? moveDisabledReason
                            : scanEnabled
                              ? t('winchControl.button.startTooltip')
                              : t('winchControl.button.moveTooltip')
                    }
                    tooltipPlacement="left">
                    {scanEnabled
                        ? t('winchControl.button.start')
                        : t('winchControl.button.moveBioscope')}
                </Button>
            )}
        </>
    );
}
